var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgNavSubscribe(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.29 5.054c-2.273 1.428-6.763 4.25-9.592 5.95-1.599.96-4.282-.2-5.015-2.24-.733-2.039.855-4.597 2.667-4.597h11.133c1.098 0 1.653 1.15 1.353 1.804-.092.197-3.23 6.686-4.653 9.656-.811 1.683-3.686 2.191-5.423.89-1.737-1.301-1.812-4.3-.297-5.299 2.272-1.498 7.454-4.717 9.902-6.221"
  })));
}

export default SvgNavSubscribe;